import React from "react";
import { useSelector } from "react-redux";

const GlobalLoader = () => {
const activeRequests = useSelector((state) => state.loader.activeRequests);
  if (activeRequests === 0) return null;
  return (
    <div className="global-loader-overlay">
      <div className="spinner"></div>
    </div>
  );
};

export default GlobalLoader;
